import { APP_INITIALIZER, inject, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
} from '@angular/router';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CookieBannerComponent } from './_components/cookie-banner/cookie-banner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginModule } from './login/login.module';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { ModalNotificacionModule } from './admin/shared/modals/modal-notificacion/modal-notificacion.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { JwtInterceptor } from './_interceptors/jwt.interceptor';
import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { FormularioConCambiosGuard } from './_guards/formulario-con-cambios.guard';
import { ModalFormularioEditadoModule } from './admin/shared/modals/modal-formulario-editado/modal-formulario-editado.module';
import { ModalVerCondicionesModule } from './admin/shared/modals/modal-ver-condiciones/modal-ver-condiciones.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ProvinciaService } from './_services/provincia.service';
import { catchError, firstValueFrom, of, timeout } from 'rxjs';
import { EntornoService } from './_services/entorno.service';

registerLocaleData(es);

function inicializarApp(provinciaService: ProvinciaService) {
  return () =>
    firstValueFrom(
      provinciaService.cargarProvincias().pipe(
        timeout(10000),
        catchError(() => of([]))
      ),
    );
}

function entornoAppInitializer(entornoService: EntornoService) {
  return () => firstValueFrom(entornoService.updateEntorno().pipe(
    timeout(10000),
    catchError(() => of(null))
  ));
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ReactiveFormsModule,
    LoginModule,
    HttpClientModule,
    ModalNotificacionModule,
    ModalFormularioEditadoModule,
    ModalVerCondicionesModule,
    MatDialogModule,
    CookieBannerComponent,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: inicializarApp,
      deps: [ProvinciaService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: entornoAppInitializer,
      deps: [EntornoService],
      multi: true,
    },
    FormularioConCambiosGuard,
    provideAnimations(),
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
